import UseManifest from './useManifest';

export default {
  UseManifest,
};
